import { computed } from "vue";
import { useRoute } from "vue-router";
import { useUiStore } from "@/stores/ui";
import type { AppHeaderSubpageMeta } from "@/types/app-header-route";

export interface ResolvedAppHeaderSubpage {
  title: string;
  showBack: boolean;
}

/**
 * Resolves back + title for the main app header from `route.meta.appHeader`
 * and optionally `uiStore.detailChromeTitle`.
 */
export function useResolvedAppHeaderSubpage() {
  const route = useRoute();
  const uiStore = useUiStore();

  return computed((): ResolvedAppHeaderSubpage | null => {
    const cfg = route.meta.appHeader as AppHeaderSubpageMeta | undefined;
    if (!cfg?.title) return null;

    const title =
      cfg.preferDetailChromeTitle && uiStore.detailChromeTitle
        ? uiStore.detailChromeTitle
        : cfg.title;

    if (!title) return null;

    return {
      title,
      showBack: cfg.showBack !== false,
    };
  });
}
